import { arrayBufferToBase64, base64ToByteArray } from '../utils/utils';
export function deserializeEntry(item) {
    return ({
        id: item.id,
        userId: item.userId,
        addedAt: new Date(item.addedAt),
        verifiedById: item.verifiedById,
        lastSeenId: item.lastSeenId,
        requestorPublicKey: base64ToByteArray(item.requestorPublicKey),
        requestorSignature: item.requestorSignature ? base64ToByteArray(item.requestorSignature) : null,
        verifierSignature: base64ToByteArray(item.verifierSignature),
        blockchainSignature: base64ToByteArray(item.blockchainSignature),
        operation: item.operation,
        keyType: item.keyType,
        version: item.version
    });
}
export function serializeEntry(item) {
    return ({
        id: item.id,
        userId: item.userId,
        addedAt: item.addedAt.toISOString(),
        verifiedById: item.verifiedById,
        lastSeenId: item.lastSeenId,
        requestorPublicKey: arrayBufferToBase64(item.requestorPublicKey),
        requestorSignature: item.requestorSignature ? arrayBufferToBase64(item.requestorSignature) : "",
        verifierSignature: arrayBufferToBase64(item.verifierSignature),
        blockchainSignature: arrayBufferToBase64(item.blockchainSignature),
        operation: item.operation,
        keyType: item.keyType,
        version: item.version
    });
}
